// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes limitBar-module_animateLimits__u6fWy {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(0);
    }
}
.limitBar-module_progressBarLine__KrTWz {
    animation-duration: 1.2s;
    animation-name: limitBar-module_animateLimits__u6fWy;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Bars/limitBar.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,wBAAwB;IACxB,oDAA6B;IAC7B,4BAA4B;IAC5B,sCAAsC;AAC1C","sourcesContent":["@keyframes animateLimits {\n    0% {\n        transform: translateX(-100%);\n    }\n\n    100% {\n        transform: translateX(0);\n    }\n}\n.progressBarLine {\n    animation-duration: 1.2s;\n    animation-name: animateLimits;\n    animation-iteration-count: 1;\n    animation-timing-function: ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressBarLine": `limitBar-module_progressBarLine__KrTWz`,
	"animateLimits": `limitBar-module_animateLimits__u6fWy`
};
export default ___CSS_LOADER_EXPORT___;
